const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://apicabaza.creago.be/rest/cabaza';
const DEFAULT_API_KEY = 'cabaza_api_key_2024_change_me';

function headers() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': DEFAULT_API_KEY
    };
}

export const getActiveTutorials = async (lang = 'fr') => {
    const res = await fetch(`${API_BASE_URL}/tutorials/active?lang=${lang}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    return data.data || data.DATA || [];
};

export const getTutorialFull = async (uuid, lang = 'fr') => {
    const res = await fetch(`${API_BASE_URL}/tutorials/${uuid}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    const tutorial = data.data || data.DATA || null;
    if (tutorial) {
        tutorial.steps = tutorial.steps || tutorial.STEPS || [];
    }
    return tutorial;
};

export const recordTutorialCompletion = async (uuid, { userUuid = '', stepsCompleted = 0, totalSteps = 0, completed = false }) => {
    try {
        await fetch(`${API_BASE_URL}/tutorials/${uuid}/completion`, {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({ userUuid, stepsCompleted, totalSteps, completed })
        });
    } catch (err) {
        console.warn('[tutorials] recordCompletion failed', err?.message || err);
    }
};
